export default "__VITE_PUBLIC_ASSET__a29a8ef7__"